/** Persist team invite token across login ↔ signup ↔ back navigation (Slack/Notion pattern). */

const STORAGE_KEY = 'halr_pending_invite_token';

export function stashPendingInviteToken(token: string | null | undefined): void {
  if (typeof window === 'undefined' || !token?.trim()) return;
  window.sessionStorage.setItem(STORAGE_KEY, token.trim());
}

export function peekPendingInviteToken(): string | null {
  if (typeof window === 'undefined') return null;
  const raw = window.sessionStorage.getItem(STORAGE_KEY);
  return raw?.trim() ? raw.trim() : null;
}

export function clearPendingInviteToken(): void {
  if (typeof window === 'undefined') return;
  window.sessionStorage.removeItem(STORAGE_KEY);
}

/** `/invite/abc123` → `abc123` */
export function inviteTokenFromRedirect(redirect: string | null | undefined): string | null {
  if (!redirect?.startsWith('/invite/')) return null;
  const token = redirect.slice('/invite/'.length).split('/')[0]?.trim();
  return token || null;
}

export function resolveInviteRedirect(
  queryRedirect: string | null | undefined,
): string | null {
  if (queryRedirect?.startsWith('/invite/')) return queryRedirect;
  const token = peekPendingInviteToken();
  return token ? `/invite/${token}` : null;
}

const CLAIM_KEY = 'halr_pending_claim_token';

export function stashPendingClaimToken(token: string | null | undefined): void {
  if (typeof window === 'undefined' || !token?.trim()) return;
  window.sessionStorage.setItem(CLAIM_KEY, token.trim());
}

export function peekPendingClaimToken(): string | null {
  if (typeof window === 'undefined') return null;
  const raw = window.sessionStorage.getItem(CLAIM_KEY);
  return raw?.trim() ? raw.trim() : null;
}

export function clearPendingClaimToken(): void {
  if (typeof window === 'undefined') return;
  window.sessionStorage.removeItem(CLAIM_KEY);
}

function claimPath(value: string | null | undefined): string | null {
  if (!value?.startsWith('/claim/')) return null;
  const token = value.slice('/claim/'.length).split(/[?#]/)[0] || '';
  if (!/^[A-Za-z0-9_-]{20,200}$/.test(token)) return null;
  return `/claim/${token}`;
}

/** Invite or a provision claim link. Nothing else, so login cannot be sent off-site. */
export function resolveAuthReturnPath(queryRedirect: string | null | undefined): string | null {
  const claim = claimPath(queryRedirect);
  if (claim) return claim;
  return resolveInviteRedirect(queryRedirect) || (peekPendingClaimToken() ? `/claim/${peekPendingClaimToken()}` : null);
}

export function authPathWithInviteRedirect(
  basePath: '/login' | '/signup',
  queryRedirect: string | null | undefined,
): string {
  const redirect = resolveInviteRedirect(queryRedirect);
  return redirect ? `${basePath}?redirect=${encodeURIComponent(redirect)}` : basePath;
}
